import { useRef, useState } from 'react';

import PropTypes from 'prop-types';
import { filter } from 'lodash';

import {
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  FormControlLabel,
  Checkbox,
  Stack,
  FormControl,
  Select,
  MenuItem
} from '@mui/material';

import { useTranslation } from '../../common/LocalizationProvider';
import PermissionSearch from './PermissionSearch';

function applySearch(array, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  if (query) {
    return filter(
      array,
      (item) =>
        item.name.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        (item.prenom !== undefined
          ? item.prenom.toLowerCase().indexOf(query.toLowerCase()) !== -1
          : false)
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

PermissionDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  allObject: PropTypes.array.isRequired,
  linkedObject: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  permissionClub: PropTypes.array,
  handleChangeStatus: PropTypes.func
};
export default function PermissionDialog(props) {
  const t = useTranslation();

  const {
    onClose,
    open,
    handleChange,
    allObject,
    linkedObject,
    title,
    permissionClub,
    handleChangeStatus,
    ...other
  } = props;

  const radioGroupRef = useRef(null);

  const handleEntering = () => {
    if (radioGroupRef.current != null) {
      radioGroupRef.current.focus();
    }
  };

  const handleOk = () => {
    onClose();
  };

  const [search, setSearch] = useState('');
  const handleSearch = (event) => setSearch(event.target.value);

  const searchObject = applySearch(allObject, search);

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
      maxWidth="xs"
      TransitionProps={{ onEntering: handleEntering }}
      open={open}
      {...other}
    >
      <DialogTitle>{t(title)}</DialogTitle>
      <PermissionSearch searchName={search} onSearchName={handleSearch} />
      <DialogContent dividers>
        <Stack direction="column">
          {searchObject.map(
            (option) =>
              option && (
                <Stack direction="row" key={option.id}>
                  <FormControlLabel
                    value={option.id}
                    control={
                      <Checkbox
                        value={option.id}
                        onChange={handleChange}
                        ref={radioGroupRef}
                        checked={
                          linkedObject.length > 0
                            ? linkedObject.map((item) => item.id).includes(option.id)
                            : false
                        }
                      />
                    }
                    label={
                      option.prenom === undefined ? option.name : `${option.prenom} ${option.name}`
                    }
                  />
                  {permissionClub !== undefined && (
                    <FormControl sx={{ minWidth: 120 }} variant="standard">
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={
                          permissionClub.map((item) => item.groupid).includes(option.id)
                            ? permissionClub.find((item) => item.groupid === option.id).status
                            : ''
                        }
                        label="Status"
                        onChange={(e) => handleChangeStatus(option.id, e.target.value)}
                      >
                        <MenuItem value={0}>{t('fields_Admin')}</MenuItem>
                        <MenuItem value={1}>{t('fields_Manager')}</MenuItem>
                        <MenuItem value={2}>{t('fields_Instructor')}</MenuItem>
                        <MenuItem value={3}>{t('fields_Pilot+')}</MenuItem>
                        <MenuItem value={4}>{t('fields_Pilot')}</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                </Stack>
              )
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOk}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
}
